/**
 * @fileoverview GameState Utilities - ゲーム状態判定ユーティリティ
 * 広範囲で使用されるセマンティックラッパー
 */

import { STATE_PATHS } from '../constants/state-paths.js';

/**
 * ユーザー操作可能状態の判定
 * @param {Object} gameState - GameStateインスタンス
 * @returns {boolean} 操作可能フラグ
 */
export function canInteract(gameState) {
  return gameState.getState(STATE_PATHS.CORE_STATUS) === 'ready';
}

/**
 * ゲーム開始可能状態の判定
 * @param {Object} gameState - GameStateインスタンス
 * @returns {boolean} 開始可能フラグ
 */
export function canStartGame(gameState) {
  return gameState.getState(STATE_PATHS.CORE_STATUS) === 'title';
}

/**
 * スキル使用可能状態の判定
 * @param {Object} gameState - GameStateインスタンス
 * @returns {boolean} スキル使用可能フラグ
 */
export function canUseSkill(gameState) {
  const status = gameState.getState(STATE_PATHS.CORE_STATUS);
  const ui = gameState.getState(STATE_PATHS.UI);
  return status === 'ready' && ui.remainingSkillUses > 0;
}

/**
 * メニュー開閉可能状態の判定
 * @param {Object} gameState - GameStateインスタンス
 * @returns {boolean} メニュー操作可能フラグ
 */
export function canOpenMenu(gameState) {
  const status = gameState.getState(STATE_PATHS.CORE_STATUS);
  const ui = gameState.getState(STATE_PATHS.UI);
  return (status === 'title' || status === 'ready') && !ui.isSkillTargeting;
}

/**
 * マッチコールアウト表示判定
 * @param {Object} gameState - GameStateインスタンス
 * @returns {boolean} マッチコールアウト表示フラグ
 */
export function shouldShowMatchCallout(gameState) {
  return gameState.getState(STATE_PATHS.CORE_STATUS) === 'processing';
}
